import React from "react";
import ReactDOM from "react-dom/client";
import "./theme.css";
import App from "./App";

const Main_Html_elem = document.getElementById("root");

const root = ReactDOM.createRoot(Main_Html_elem);
root.render(<App />);
